import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import {
  Screen1,
  Points,
  Learn,
  Hinder,
  ResultsStudents,
  Speaker,
  Revs,
  Advance,
} from '../../../components/LandingTemplates/legko_uchitsya';

const TITLE = 'Как легко учиться в школе по всем предметам | Центр образовательных технологий Advance';
const DESCRIPTION =
  'Секреты обучения от эксперта, который был двоечником, но смог закончить школу в 14 лет, вуз в 20, а в 21 уже создал свой бизнес';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'29a4cdd662e241b8e020f78fe0acc72615b1f530'} id={'1367813'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 widget={widget} id={'legko_uchitsya_e'} />
      <Points widget={widget} />
      <Learn />
      <Hinder widget={widget} />
      <ResultsStudents />
      <Speaker />
      <Revs widget={widget} />
      <Advance widget={widget} />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
